import React from 'react';
import { cxTw } from '@asigna/kit';
import closeIcon from 'images/close.svg';

type Props = {
  onClick: () => void;
  className?: string;
};

export const ModalCloseButton: React.FC<Props> = ({ onClick, className }) => (
  <button
    className={cxTw(
      'w-[40px] h-[40px] border border-black-4 hover:bg-white-10 active:bg-white-10 rounded-[8px] p-[8px] transition-all',
      className
    )}
    onClick={onClick}
  >
    <img src={closeIcon} alt="close icon" width={24} height={24} />
  </button>
);
